import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://mgassetmanagement.com";
const SITE_NAME = "MG Asset Management";

const DEFAULT_SEO = {
  title: "MG Asset Management | Wealth & Investment Management",
  description:
    "MG Asset Management provides wealth planning, portfolio management, retirement planning, real estate investments, and alternative investment solutions.",
};

const SEO_BY_PATH = {
  "/": DEFAULT_SEO,
  "/account-types": {
    title: "Account Types | MG Asset Management",
    description:
      "Explore MG Asset Management account types designed for wealth planning, portfolio management, and long term investment objectives.",
  },
  "/contact": {
    title: "Contact MG Asset Management",
    description:
      "Contact MG Asset Management to discuss wealth planning, retirement planning, portfolio management, and investment solutions.",
  },
  "/retirement-planning": {
    title: "Retirement Planning | MG Asset Management",
    description:
      "MG Asset Management helps clients plan for retirement with disciplined income planning, portfolio structure, and long term wealth preservation.",
  },
  "/real-estate": {
    title: "Real Estate Investments | MG Asset Management",
    description:
      "Learn how MG Asset Management incorporates real estate investments into diversified wealth and income strategies.",
  },
  "/mortgage-backed-income": {
    title: "Mortgage Backed Income | MG Asset Management",
    description:
      "MG Asset Management provides mortgage backed income and structured credit strategies focused on collateral quality and durable cash flow.",
  },
  "/regulatory": {
    title: "Regulatory Information | MG Asset Management",
    description:
      "Review regulatory information for MG Asset Management and its investment management services.",
  },
  "/risk-disclosure": {
    title: "Risk Disclosure | MG Asset Management",
    description:
      "Read MG Asset Management risk disclosures for investment management, portfolio strategies, and market-related risks.",
  },
  "/privacy": {
    title: "Privacy Policy | MG Asset Management",
    description:
      "Read the MG Asset Management privacy policy and learn how client and website information is handled.",
  },
  "/terms": {
    title: "Terms and Conditions | MG Asset Management",
    description:
      "Read the MG Asset Management terms and conditions for website use and investment service information.",
  },
};

function setMeta(selector, attribute, value) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    const nameMatch = selector.match(/meta\[name=['"](.+?)['"]\]/);
    const propertyMatch = selector.match(/meta\[property=['"](.+?)['"]\]/);

    if (nameMatch) element.setAttribute("name", nameMatch[1]);
    if (propertyMatch) element.setAttribute("property", propertyMatch[1]);

    document.head.appendChild(element);
  }

  element.setAttribute(attribute, value);
}

function setCanonical(url) {
  let canonical = document.head.querySelector("link[rel='canonical']");

  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute("href", url);
}

export default function SEOManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const normalizedPath = pathname === "/" ? "/" : pathname.replace(/\/$/, "");
    const seo = SEO_BY_PATH[normalizedPath] || DEFAULT_SEO;
    const canonicalUrl = `${SITE_URL}${normalizedPath === "/" ? "/" : normalizedPath}`;

    document.title = seo.title;
    setCanonical(canonicalUrl);
    setMeta("meta[name='description']", "content", seo.description);
    setMeta("meta[property='og:type']", "content", "website");
    setMeta("meta[property='og:site_name']", "content", SITE_NAME);
    setMeta("meta[property='og:title']", "content", seo.title);
    setMeta("meta[property='og:description']", "content", seo.description);
    setMeta("meta[property='og:url']", "content", canonicalUrl);
    setMeta("meta[name='twitter:card']", "content", "summary_large_image");
    setMeta("meta[name='twitter:title']", "content", seo.title);
    setMeta("meta[name='twitter:description']", "content", seo.description);
  }, [pathname]);

  return null;
}
